import { Experiences } from "../components/ExperiencesCard";

const experiences: Experiences[] = [
  {
    slug: "IRTS2",
    logo: "/logos/irts.png",
    title: "IRTS - Chargé de projets informatiques - CDI",
    since: "Oct. 2023 - Aujourd'hui",
    excerpt: "Dans le cadre du déploiement d’un ERP destiné à 90 collaborateurs, 800 formateurs et 3000 étudiants, j’ai accompagné l'IRTS confronté à un dilemme stratégique : poursuivre le développement interne ou externaliser la solution auprès d’un éditeur spécialisé.",
    tasks: [
      {
        label: "Projets",
        items: [
          "Etablir un benchmark des éditeurs logiciels existants",
          "Proposition de solutions pour la réorganisation des processus métiers",
          "Aider à la décision via des exports statistiques ou KPI"
        ],
      },
      {
        label :"Technique",
        items:[
          "Transfert des données de l'ancien ERP vers le nouveau",
          "Surcouche applicative pour éviter des régressions métiers",
          "Mise en place d'API pour connecter l'ERP à des outils externes (Microsoft 365, Sage, Parcoursup, Moodle)"
        ],
      },
      {
        label :"Formation",
        items:[
          "Accompagner les utilisateurs à la prise en main du nouvel outil",
        ],
      }
    ],


    tech: ["SQL", "PHP", "React", "TypeScript", "Javascript"]
  },
  {
    slug: "IRTS1",
    logo: "/logos/irts.png",
    title: "IRTS - Alternant Responsable des applications métiers - Contrat Apprentissage",
    since: "Nov. 2021 - Oct. 2023",
    excerpt: "...",
    tasks: [
      {
        label: "",
        items: [
          "Audit de l'existant",
          "Analyse de besoins",
          "Analyse des résultats pour optimiser les performances des applications internes",
          "Prise de recul sur le contexte applicatif de l'entreprise",
          "Support, ticketting logiciels (niveau 1, 2 et 3)"
        ]
      }],
    tech: ["PHP", "Javascript", "Windev"]
  },
  {
    slug: "DARVA",
    logo: "/logos/darva.png",
    title: "DARVA - Alternant Développeur - Contrat Apprentissage",
    since: "Sept. 2020 - Sept. 2021",
    excerpt: "...",
    tasks: [
      {
        label: "",
        items: [
          "Développement complet de scripts et automatisations afin de couvrir l’ensemble des fonctionnalités attendues",
          "Amélioration de la productivité des équipes grâce à la mise en place d’outils de test automatisés (Cypress, Jira, GitHub, Slack)",
          "Analyse des résultats pour optimiser les performances des applications internes"
        ]
      }],


    tech: ["React", "TypeScript", "Cypress", "Méthode Agile Scrum"]
  },
  {
    slug: "EINDEN",
    logo: "/logos/einden.png",
    title: "EINDEN - Développeur Junior - Stage",
    since: "Janv. 2020 - Fev. 2020",
    excerpt: "...",
    tasks: [
      {
        label: "",
        items: [
          "Développement de fonctionnalités web sur une application MVC (PHP, JQuery, Ajax, JavaScript)",
          "Contribution au renforcement des performances et à l’optimisation de l’expérience utilisateur"
        ]
      }],
    tech: ["PHP", "Javascript", "JQuery"]
  }
];
export default experiences;
